import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div className="card max-w-3xl mx-auto space-y-4" data-testid="terms-page">
      <h1 className="text-base md:text-lg font-semibold">Terms of use</h1>
      <p className="text-muted-foreground">
        GDI Academy provides educational learning support for New Zealand learner drivers. It does
        not replace the official New Zealand Road Code, professional practical instruction, or NZTA
        / Waka Kotahi services.
      </p>
      <p className="text-muted-foreground">
        Practice mock tests are learning tools only. A practice mock result is not an official NZTA
        test result.
      </p>
      <p className="text-muted-foreground">
        You must keep your login details confidential and use the Academy only for lawful learning
        purposes. Academy logins are not GDI operational logins. There is no single sign-on.
      </p>
      <p className="text-muted-foreground">
        GDI Academy is not an NZTA-approved course and does not guarantee a test pass or licence.
      </p>
      <Link to="/register" className="btn-outline inline-flex" data-testid="terms-back-register">
        Back to signup
      </Link>
    </div>
  );
}
